import {
  makeStyles,
  Grid,
  Box,
  Paper,
  Typography,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { useCallback, useEffect, useState } from "react";
import { useDataProvider } from "react-admin";

interface IAssignmentSummaryBox {
  busSchedulePlanId: number;
  date: string;
}

const useStyles = makeStyles({
  paper: {
    padding: "6px 16px",
  },
  subTitle: {
    fontSize: "16px",
  },
  description: {
    fontSize: "34px",
  },
});

const AssignmentSummaryBox = ({
  busSchedulePlanId,
  date,
}: IAssignmentSummaryBox) => {
  const [assignmentSummary, setAssignmentSummary] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const classes = useStyles();
  const { customGetListWithStaticParams } = useDataProvider();

  const getAssignmentSummary = useCallback(
    async (busSchedulePlanId: number, date: string) => {
      try {
        const assignmentSummaryResponse = await customGetListWithStaticParams(
          `summaries/assignment?BusSchedulePlanId=${busSchedulePlanId}&Date=${date}`
        );

        setAssignmentSummary(assignmentSummaryResponse.data);
        setIsLoading(false);
        setIsLoaded(true);
      } catch (error) {
        console.log("ERROR", error);
        setIsLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    if (busSchedulePlanId && date) {
      setIsLoading(true);
      setIsLoaded(false);
      getAssignmentSummary(busSchedulePlanId, date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlanId, date]);

  return (
    <>
      {isLoading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <>
          {isLoaded ? (
            <SanitizedGrid container spacing={10}>
              <Grid item xs={3}>
                <Box>
                  <Paper className={classes.paper}>
                    <SanitizedGrid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          className={classes.subTitle}
                          variant="h6"
                          align="center"
                        >
                          Total Assignments
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Divider />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography
                          className={classes.description}
                          variant="h6"
                          gutterBottom
                          align="center"
                        >
                          {assignmentSummary.totalTrip}
                        </Typography>
                      </Grid>
                    </SanitizedGrid>
                  </Paper>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box>
                  <Paper className={classes.paper}>
                    <SanitizedGrid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          className={classes.subTitle}
                          variant="h6"
                          align="center"
                        >
                          Assignments Not Started
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Divider />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography
                          className={classes.description}
                          variant="h6"
                          gutterBottom
                          align="center"
                        >
                          {assignmentSummary.tripReady}
                        </Typography>
                      </Grid>
                    </SanitizedGrid>
                  </Paper>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography
                        className={classes.subTitle}
                        variant="h6"
                        align="center"
                      >
                        Assignments Running
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography
                        className={classes.description}
                        variant="h6"
                        gutterBottom
                        align="center"
                      >
                        {assignmentSummary.tripStarted}
                      </Typography>
                    </Grid>
                  </SanitizedGrid>
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography
                        className={classes.subTitle}
                        variant="h6"
                        align="center"
                      >
                        Assignments Ended
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography
                        className={classes.description}
                        variant="h6"
                        gutterBottom
                        align="center"
                      >
                        {assignmentSummary.tripEnded}
                      </Typography>
                    </Grid>
                  </SanitizedGrid>
                </Paper>
              </Grid>
            </SanitizedGrid>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default AssignmentSummaryBox;
